/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import BucketedDataTable from '../../components/BucketedDataTable';
import BucktedDataTableControls from '../../components/BucktedDataTableControls';

class InstanceDetailsMaintenances extends React.Component {
  constructor(props) {
    super(props);
    this.onFilter = this.onFilter.bind(this);
  }

  onFilter(event) {
    const value = event.target.value;
    this.props.bucketedList.actions.filter(value);
  }

  render() {
    const { bucketedList } = this.props;
    const totalMaintenances = bucketedList.buckets.reduce((acc, bucket) => {
      return acc + bucket.rows.length;
    }, 0);

    return (
      <div>
        <BucktedDataTableControls
          onChange={this.onFilter}
          text={`${moment().format('M/D/YY')} - ${moment().add(1, 'year').endOf('year').format('M/D/YY')} • ${totalMaintenances} Items`}
          expandAll={bucketedList.actions.expandAll}
          collapseAll={bucketedList.actions.collapseAll}
        />
        <BucketedDataTable
          bucketedList={bucketedList}
        />
      </div>
    );
  }
}

export default InstanceDetailsMaintenances;
